import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const lead: AdminBlockTypeAttribute = {
  label: 'Show lead',
  key: 'lead',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default lead;
